import { getUserManager, oAuthEnabled } from './OidcService';

const TOKEN_VALIDITY_IN_MINUTES = 1000 * 60 * 15;
export const REFRESH_TOKEN_KEY = 'refresh_token';
export const ACCESS_TOKEN_KEY = 'access_token';
const ACCESS_TOKEN_KEY_EXP = 'access_token_exp';

const TokenService = {
  getAccessToken: (): Promise<string | undefined> => {
    if (oAuthEnabled()) {
      return getUserManager().then((manager) => {
        if (!manager) return undefined;
        return manager.getUser().then((user) => user?.access_token ?? undefined);
      });
    } else {
      return Promise.resolve(localStorage.getItem(ACCESS_TOKEN_KEY) ?? undefined);
    }
  },

  getAccessTokenExpiration: (): string | undefined => localStorage.getItem(ACCESS_TOKEN_KEY_EXP) ?? undefined,

  saveAccessToken: (accessToken: string) => {
    localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
    // set timestamp, needed for onPrem. Times between onPrem backend and frontend could differ
    localStorage.setItem(ACCESS_TOKEN_KEY_EXP, String(Date.now() + TOKEN_VALIDITY_IN_MINUTES));
  },

  removeAccessToken:() => {
    localStorage.removeItem(ACCESS_TOKEN_KEY);
    localStorage.removeItem(ACCESS_TOKEN_KEY_EXP);
  },

  getRefreshToken: (): Promise<string | undefined> => {
    if (oAuthEnabled()) {
      return getUserManager().then((manager) => {
        if (!manager) return undefined;
        return manager.getUser().then((user) => user?.refresh_token ?? undefined);
      });
    } else {
      return Promise.resolve(localStorage.getItem(REFRESH_TOKEN_KEY) ?? undefined);
    }
  },

  saveRefreshToken:(refreshToken: string) => {
    localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
  },

  removeRefreshToken:() => {
    localStorage.removeItem(REFRESH_TOKEN_KEY);
  }
};

export { TokenService };
